import "./App.css";
import Nav from "./Components/Nav/Nav";
import "./Components/Fonts/ginebra_font.ttf";
import "./Components/Fonts/Vedacity-DEMO.ttf";
import About from "./Components/About/About";
import Premium from "./Components/Premium/Premium";
import Review from "./Components/Review/Review";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Nav />
      <About />
      <Premium />
      <Review />
      <Footer />
    </div>
  );
}

export default App;
